import axios from 'axios';
import * as Api from '../constants/Api';
import * as CONST from '../constants/Const';
// import authConfig from '../constants/AuthConfig'
import {
  loadStart,
  loadEnd,
  modalOpen,
  modalClose,
  errorShow,
  errorClose,
  errorReset
} from './App';
// import AWS from 'aws-sdk';
import * as USERCODE from './User';

// const cognitoUser = null;

export const modalCloseInAuth = () => {
  return dispatch => {
    dispatch(modalClose());
  };
};

export const modalErrorClose = () => {
  return dispatch => {
    dispatch(errorClose());
  };
};

export const resetError = () => {
  return dispatch => {
    dispatch(errorReset());
  };
};

export const signUp = email => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(Api.signUpApi, { email, code: 'InitialLogin', admin: false })
      .then(res => {
        const body = JSON.parse(res.data.body);
        const error = body.errorMessage;
        if (error) {
          dispatch(errorShow(error.errMsg));
          dispatch(loadEnd());
          return;
        }
        const text = body.data;
        dispatch(modalOpen(text));
        dispatch(loadEnd());
      })
      .catch(() => {
        // console.log('エラーやで', err)
        dispatch(errorShow(CONST.UNKNOWN_ERROR));
        dispatch(loadEnd());
      });
  };
};

export const passwordConfirm = (email, confirmCode, password) => {
  return dispatch => {
    dispatch(loadStart());
    console.log({
      email,
      code: 'passwordRegistration',
      confirmationCode: confirmCode,
      password
    });
    axios
      .post(Api.signUpApi, {
        email,
        code: 'passwordRegistration',
        confirmationCode: confirmCode,
        password
      })
      .then(res => {
        const body = JSON.parse(res.data.body);
        const error = body.errorMessage;
        if (error) {
          dispatch(errorShow(error.errMsg));
          dispatch(loadEnd());
          return;
        }
        const text = '';
        dispatch(modalOpen(text));
        dispatch(loadEnd());
      })
      .catch(() => {
        // console.log('エラーやで', err)
        dispatch(errorShow(CONST.UNKNOWN_ERROR));
        dispatch(loadEnd());
      });
  };
};

export const signIn = (email, password) => {
  return dispatch => {
    dispatch(loadStart());

    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    };

    axios
      .post(Api.signInApi, { email, code: 'login', password }, headers)
      .then(res => {
        const body = JSON.parse(res.data.body);
        // console.log('ログイン', body, JSON.stringify(body.data.enterprise))
        const error = body.errorMessage;
        if (error) {
          dispatch(errorShow(error.errMsg));
          dispatch(loadEnd());
          return;
        }

        localStorage.setItem('current_user', JSON.stringify(body.data.enterprise));

        // 施設情報
        const user = body.data.enterprise;
        // const cognitoUser = body.data.cognitoUser;

        dispatch({ type: USERCODE.LOGGED_IN, data: user });

        const text = `ログイン成功！`;
        dispatch(modalOpen(text));
        dispatch(loadEnd());

        // eslint-disable-next-line consistent-return
        return Promise.resolve(user);
      })
      .catch(err => {
        dispatch(loadEnd());
        return Promise.reject(err);
      });
  };
};

export const loginUp = email => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(Api.signUpApi, { email, code: 'InitialLogin' })
      .then(() => {
        const text = `ご入力いただいたメールアドレスへ、仮パスワードを送付しました。\nメールをご確認ください。`;
        dispatch(modalOpen(text));
        dispatch(loadEnd());
      })
      .catch(() => {
        // console.log('エラーやで', err)
        dispatch(errorShow(CONST.UNKNOWN_ERROR));
        dispatch(loadEnd());
      });
  };
};

// send reset password request
export const requestReset = email => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(Api.signUpApi, { email, code: 'reset_request' })
      .then(res => {
        const body = JSON.parse(res.data.body);
        const error = body.errorMessage;
        if (error) {
          dispatch(errorShow(error.errMsg));
          dispatch(loadEnd());
          return;
        }
        const text = 'Check your email.';
        dispatch(modalOpen(text));
        dispatch(loadEnd());
      })
      .catch(() => {
        dispatch(errorShow(CONST.UNKNOWN_ERROR));
        dispatch(loadEnd());
      });
  };
};

// reset password
export const resetpassword = (email, confirmationCode, oldpassword, newpassword) => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(Api.signUpApi, {
        email,
        confirmationCode,
        oldpassword,
        newpassword,
        code: 'reset_password_confirm'
      })
      .then(res => {
        const body = JSON.parse(res.data.body);
        const error = body.errorMessage;
        if (error) {
          dispatch(errorShow(error.errMsg));
          dispatch(loadEnd());
          return;
        }
        const text = 'Password changed';
        dispatch(modalOpen(text));
        dispatch(loadEnd());
      })
      .catch(() => {
        dispatch(errorShow(CONST.UNKNOWN_ERROR));
        dispatch(loadEnd());
      });
  };
};

// send reset password request
export const forgotPassword = email => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(Api.signUpApi, { email, code: 'forgot_password' })
      .then(res => {
        const body = JSON.parse(res.data.body);
        const error = body.errorMessage;
        if (error) {
          dispatch(errorShow(error.errMsg));
          dispatch(loadEnd());
          return;
        }
        const text = 'Check your email.';
        dispatch(modalOpen(text));
        dispatch(loadEnd());
      })
      .catch(() => {
        dispatch(errorShow(CONST.UNKNOWN_ERROR));
        dispatch(loadEnd());
      });
  };
};

// reset password
export const confirmPassword = (email, confirmationCode, password) => {
  return dispatch => {
    dispatch(loadStart());
    axios
      .post(Api.signUpApi, {
        email,
        confirmationCode,
        password,
        code: 'confirm_password'
      })
      .then(res => {
        const body = JSON.parse(res.data.body);
        const error = body.errorMessage;
        if (error) {
          dispatch(errorShow(error.errMsg));
          dispatch(loadEnd());
          return;
        }
        const text = 'Check your email.';
        dispatch(modalOpen(text));
        dispatch(loadEnd());
      })
      .catch(() => {
        dispatch(loadEnd());
        dispatch(errorShow(CONST.UNKNOWN_ERROR));
      });
  };
};

// export const logoutActions=()=> {

//   if (cognitoUser != null) {
//       if (AWS.config.credentials && AWS.config.credentials.clearCachedId) {
//           AWS.config.credentials.clearCachedId();
//       }
//       cognitoUser.signOut();
//   }

//   return true
// }

// export const getSession=(session)=> {

//   cognitoUser.getSession((err, session) =>{
//     if (err) {
//         console.log(err)
//     }
//     console.log(session)
//     console.log('session validity: ' + session.isValid());
//   });

//   return true
// }
